<template>
  <div class="Page inner">
    <div class="innerPageHead">
      <div class="innerPageBanner mushroom">
        <b-container>
          <b-row
            align-h="center"
            align-v="center"
            cols="2"
          >
            <b-col class="text-center">
              <div
                class="innerPageBannerPic pt-md-5 px-md-5 pb-md-3 pt-5 px-4 pb-2"
              >
                <b-img
                  :src="require('@/assets/imgs/icon_interpage_mushroom.png')"
                  fluid
                  alt="香菇業者"
                ></b-img>
              </div>
              <h2 class="innerPageBannerTitle">香菇業者</h2>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <b-container>
        <b-breadcrumb :items="items"></b-breadcrumb>
      </b-container>
    </div>

    <section class="shopIntro">
      <b-container>
        <b-row align-h="center" align-v="center">
          <b-col lg="8">
            <div class="shopIntroText">
              <p>
                魚池鄉擁有氣候、地形、海拔等環境優勢，香菇種植產量居全國前芧，每年3月到9月是香菇盛產期，也是觀光客休閒買菇的好季節。魚池鄉的香菇大部分以太空包方式栽培，利用這種方法種植香菇，經過裝袋、殺菌、接種後，半年便可以開始長菇，所以不僅品質優良、量多，而且菇寮裡相當乾淨，種植出的香菇口感紮實，香氣濃郁，並製作成乾、濕兩種，濕的鮮甜多汁，乾的又香又有嚼勁，深受消費者喜愛！
              </p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <div class="shopListGroup">
      <b-container>
        <b-row cols="2" cols-sm="2" cols-md="3" cols-lg="4">
          <b-col
            class="shopListItem"
            v-for="item in storeList"
            :key="item.SO_ID"
          >
            <b-link :to="'Shopinfo?id=' + item.SO_ID" class="drop-shadow">
              <div class="shopListPic">
                <b-img :src="item.MainImgUrl" fluid :alt="item.ME_NAME"></b-img>
              </div>
              <div class="shopListTitle">
                <h3>{{ item.SO_NAME }}</h3>
              </div>
            </b-link>
          </b-col>
        </b-row>
        <div class="page">
          <b-pagination
            class="pagination light-theme simple-pagination"
            v-model="pagination.page"
            :total-rows="pagination.rows"
            :per-page="pagination.perPage"
            aria-controls="my-table"
          ></b-pagination>
        </div>
      </b-container>
    </div>

    <ul id="myMenu">
      <li>
        <a href="/" tooltip="首頁" flow="left"
          ><span class="icon-home3" title="返回 魚池農易GO 首頁"></span
          ><span class="sr-only">首頁</span>
        </a>
      </li>

      <li>
        <a
          href="javascript:"
          v-scroll-to="'#top'"
          class="BackToTop"
          title="回到最頂[連結]"
          ><span class="icon-top"></span><span class="sr-only">top</span></a
        >
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        navigationActive: [],
        items: [
          {
            text: "首頁",
            href: "#/",
          },
          {
            text: "香菇業者",
            active: true,
          },
        ],
        storeListAll: [],
        storeList: [],
        pagination: {
          perPage: 8,
          page: 1,
          rows: 5,
        },
        apiStore: (data) => this.userRequest.post("Default/Store", data),
      };
    },
    mounted() {
      this.init();
    },
    watch: {
      "pagination.page"() {
        this.loading = true;
        this.setPage();
      },
    },
    methods: {
      init() {
        let json = {
          TYPE: "FRONT_LIST",
          STORE_SELECT: {
            pageIndex: this.pagination.page,
            pageSize: this.pagination.perPage,
            variety: {
              BlackTea: false,
              Coffee: false,
              Orchid: false,
              Mushroom: true,
              Fruits: false,
            },
          },
        };
        this.FunctionToken(this.APIGetStoreList, json);
      },
      setPage() {
        this.storeList = [];
        let count = this.pagination.perPage * this.pagination.page;
        let count1 = count - this.pagination.perPage;
        this.storeList = this.storeListAll.slice(count1, count);
        this.loading = false;
      },
      // api
      APIGetStoreList(data) {
        this.apiStore(data)
          .then((res) => {
            let json = JSON.parse(res.data);
            if (json.Status) {
              let jsonData = JSON.parse(json.Data);
              console.log(jsonData);
              this.storeListAll = jsonData.outData;
              this.storeList = [];
              this.pagination.rows = jsonData.totalCount;
              this.setPage();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
    },
  };
</script>
